module.exports = __webpack_public_path__ + "87be71a5d2e05cc7b4303b7ef277c5fd.pdf";